import { render, staticRenderFns } from "./QrOrderTips.vue?vue&type=template&id=4a30428e&scoped=true&"
import script from "./QrOrderTips.vue?vue&type=script&lang=js&"
export * from "./QrOrderTips.vue?vue&type=script&lang=js&"
import style0 from "./QrOrderTips.vue?vue&type=style&index=0&id=4a30428e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a30428e",
  null
  
)

export default component.exports